import { ITheme } from "../../utils/theme";

export const containerStyle = {
  background: (theme: ITheme) => theme.palette.common.white,
  paddingRight: 1,
  paddingLeft: 1,
}

export const noShiftsTextStyle = {
  mb: 1,
  textAlign: 'center',
  color: (theme: ITheme) => theme.palette.black
}

export const shiftCardWrapperStyle = (theme: ITheme) => ({
  p: 1,
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  display: 'inline-block',
  width: '100%',
})

export const availableLabelStyle = {
  float: 'right',
  color: (theme: ITheme) => theme.palette.red.A700,
  fontWeight: 'bold',
  mb: 1,
  mt: 2,
  '&.available': {
    color: (theme: ITheme) => theme.palette.green[600],
  }
}

export const shiftCardLabelStyle = (theme: ITheme) => ({
  [theme.breakpoints.down('sm')]: {
    '& .MuiFormControlLabel-label': {
      position: 'relative',
      top: '10px',
    },
  }
})

export const alertButtonStyle = {
  color: (theme: ITheme) => theme.palette.warning.light,
  fontWeight: 'bold',
  float: 'right'
}